import React, { useCallback } from 'react';
import { connect } from 'react-redux';
import { Action, AnyObject } from '@triare/auth-redux';
import {
  signUpByService as signUpByServiceAction,
  signUpErrorClear as signUpErrorClearAction,
  SignUpByServiceAction,
} from '@triare/auth-redux/dist/saga/auth/signUp';
import { useTranslation } from 'react-i18next';
import { Button } from 'antd';
import { IResolveParams, LoginSocialApple } from 'reactjs-social-login';

interface ButtonAppleProps {
  signUpByService: (payload: SignUpByServiceAction) => Action;
  signUpErrorClear: (payload: AnyObject) => Action;
}

function ButtonApple({
  signUpByService,
  signUpErrorClear,
}: ButtonAppleProps): React.ReactNode {
  // const [providerName, setProviderName] = useState('');

  const onLoginStart = useCallback(() => {
    // alert('login start')
  }, []);

  const onLogoutSuccess = useCallback(() => {
    // setProviderName('');
    // alert('logout success')
  }, []);

  const { t } = useTranslation();

  return (
    <LoginSocialApple
      client_id={process.env.REACT_APP_APPLE_ID || ''}
      scope="name email"
      onLoginStart={onLoginStart}
      redirect_uri={`${window.location.origin}/auth/callback/apple`}
      onResolve={({ provider, data }: IResolveParams) => {
        // setProviderName(provider);

        if (data && data.authorization && data.authorization.id_token) {
          const payload: SignUpByServiceAction = {
            // _query: {
            //   lang: 'en',
            // },
            method: 'apple',
            accessToken: data.authorization.id_token,
          };

          signUpByService(payload);
        }
      }}
      onReject={(err) => {
        console.log(err);
      }}
    >
      <Button type="primary" style={{ width: '100%' }}>
        {t('signUp.apple')}
      </Button>
    </LoginSocialApple>
  );
}

export default connect(null, {
  signUpByService: signUpByServiceAction,
  signUpErrorClear: signUpErrorClearAction,
})(ButtonApple);
